export default {
  /*
   * Nav Section
   */
  'nav.renewal_portal': 'Renewal Portal',
  'nav.mrs_portal': 'MRS Portal',
  'nav.select_branches': 'Select Branches',

  /*
   * Drawer Section
   */
  'drawer.dashboard': 'Dashboard',
  'drawer.renewal_portal': 'Renewal Portal',
  'drawer.completed_renewals_portal_url': 'Completed Renewals Portal',
  'drawer.reports_portal_url': 'Reports Portal',
  'drawer.imitate_employee': 'Imitate Employee',
  'drawer.admin_panel': 'Admin Panel',
  'drawer.welcome': 'Welcome',
  'drawer.select_branches': 'Select Branches',
  'drawer.inactive_branches': 'Inactive Branches',
  'drawer.version': 'Version',
  'drawer.branch_overrides': 'Branch Overrides',
  'drawer.managed_restroom_services_portal': 'MRS Portal',

  /*
   * Dashboard Panels
   */
  'Past Due': 'Past Due',
  '0-3 Months': '0-3 Months',
  '3-6 Months': '3-6 Months',
  '6-12 Months': '6-12 Months',
  '12-18 Months': '12-18 Months',
  '18+ Months': '18+ Months',
  'Awaiting Signature': 'Awaiting Signature',
  renewal_past_due: 'Past Due',
  renewal_zerotothree_months: '0-3 Months',
  renewal_threetosix_months: '3-6 Months',
  renewal_sixtotwelve_months: '6-12 Months',
  renewal_twelvetoeighteen_months: '12-18 Months',
  renewal_eighteenmonths_plus: '18+ Months',
  triggered_customers: 'Triggered Customers',
  customer_name_or_number: 'Customer name or number',

  /*
   * Dashboard Panels
   */
  'renewals_action_panel.title': 'Required Approvals',

  /*
   * Renewal page
   */
  rental_service_agreement: 'Rental Service Agreement',
  last: 'Last',
  days: 'Days',
  margin_rating: 'Margin Rating',
  bill_to: 'Bill To',
  deliver_to: 'Deliver To',
  district: 'District',
  customer: 'Customer',
  product: 'Product',
  rental_price: 'Rental Price',
  sales_price: 'Sales Price',
  wash_price: 'Wash Price',
  replace_price: 'Replace Price',
  rent_qty: 'Rent Qty',
  del_qty: 'Del Qty',
  minimum_use_percentage: 'Min Use %',
  inventory_maintenance: 'Inventory Maintenance',
  image_care_price: 'EasyCare Price',
  delivery_frequency: 'Delivery Frequency',
  current_approval_tier: 'Current Approval Tier',
  product_triggers: 'Product Triggers',
  product_added_or_removed: 'Product Added (+)\n Product Removed (-)',
  number_of_wearers: '# of Wearers',
  number_of_items_per_wearer: '# of Items/Wearer',
  circ_inv: 'Circ Inv',
  weekly_usg: 'Weekly Usage',
  start_renewal: 'Start Renewal',
  renewals_action_panel_title: 'Customers',
  close_renewal: 'Cancel Renewal',
  renewal: 'Renewal',
  next: 'Next',
  customer_uses_general_price_list: 'Customer uses General Price List',
  customer_uses_excluded_product: 'Customer uses excluded product(s)',
  customer_uses_excluded_src_types: 'Customer uses excluded SRC Types',
  customer_contract_not_viewable: 'Unable to view customer contract',
  renewal_requires_approval: 'One or more products require approval',
  product_details: 'Product Details',
  approval_required_reason: 'Approval Required Reason',
  line_item_requires_approval:
    'This product contains changes which require approval',
  renewal_created: 'Renewal created.',
  error_updating_renewal: 'Error updating renewal',
  renewal_updated: 'Renewal updated',
  error_creating_renewal: 'Error creating renewal',
  renewal_sent_forward: 'Renewal sent forward',
  error_sending_renwal_forward: 'Error sending renewal forward',
  renewal_closed: 'Renewal closed',
  error_closing_renewal: 'Error closing renewal',
  error_validating_renewal: 'error validating renewal',
  yes_Close_this_renewal: 'Yes, Cancel this renewal',
  yes_create_editable_document: 'Yes',
  cancel: 'Cancel',
  save: 'Save',
  renewal_term: 'Renewal Term',
  rollover_term: 'Rollover Term',
  options: 'Options',
  close_renewal_paragraph:
    'Are you sure you want to close this renewal without completing it? Once closed, the renewal process will have to start from the beginning.',
  service_charges: 'Service Charges',
  description: 'Description',
  amount: 'Amount',
  delivery_minimum: 'Delivery Minimum',
  service_charge: 'Service Charge',
  yes_priceprotect_customer: 'Yes, Price Protect Customer',
  no_donot_priceprotect_customer: 'No, Do Not Price Protect Customer',
  do_not_automatically_renew: 'Do not automatically renew',
  '1_year': '1 Year',
  '2_years': '2 Years',
  '3_years': '3 Years',
  '4_years': '4 Years',
  '5_years': '5 Years',
  years: 'years',
  customer_signature_required: 'Customer Signature Required',
  confirm_service_agreement:
    'The service agreement requires Customer Approval prior to completion. The customer will receive an email with a link to review and accept the service agreement. The RSR operating the customer route will also be notified to capture customer approval.',
  resend_confirm_service_agreement:
    'This service agreement is awaiting customer signature. If an email was previously provided, the customer has already received an email with a link to review. If an email has not been provided yet, the customer will need to sign on the RSR’s handheld. To resend the agreement, please verify and/or edit the email address and name below and click ‘Resend to Customer’',
  signature_full_name_placeholder: "Please enter approver's full name",
  easy_care_conversion: 'EasyCare Conversion',
  signature_email_address_placeholder: 'Please enter a valid email address',
  approval_contact: 'Approval Contact',
  contact_first_and_last_name: 'Contact First and Last Name',
  contact_email: 'Contact Email',
  select_contact: 'Select Contact',
  send_to_customer: 'Send to Customer',
  resend_to_customer: 'Resend to Customer',
  update_contact: 'Update Contact',
  competitor_pricing: 'Competitor Pricing',
  reason_for_adjustment: 'Reason for Adjustment',
  reason_for_approval: 'REASONS FOR APPROVAL',
  approval_required: 'Approval Required',
  no_reasons_provided: 'No reasons provided',
  Dialog_para:
    'The service agreement has adjustments that require managerial approval. Submit agreement for review. Once approved, the agreement will indicate it is ready to capture a signature during a future delivery ',
  submit_for_approval: 'Submit For Approval',
  green_rate: 'Green Rate',
  red_rate: 'Red Rate',
  mad_rate: 'MAD Rate',
  current_contract_rate: 'Current Contract Rate',
  current_contract_rate_and_mad: 'Current Contract Rate\\MAD Rate',
  new: 'New',
  below_red_rate_message: 'Price adjustment is below Red Rate.',
  different_tier_message: 'Price adjustment belongs to different tier.',
  no_rates_provided_message: 'No Red/Green Rates available.',
  price_approval_message: 'Price adjustment requires approval.',
  new_rate: 'New Rate',
  current_rate: 'Current Rate',
  action_not_allowed: 'Change not allowed.',
  approval_note_1: 'This will be a',
  approval_note_2: 'discount and will require an approval',
  increase: 'increase',
  discount: 'discount',
  approval_reason_message:
    'The service agreement has adjustments that require management approval. Approval is required for the following reasons',
  tier1_approval: 'Tier 1 Adjustments - GM Approval',
  tier2_approval: 'Tier 2 Adjustments - RVP Approval',
  tier3_approval: 'Tier 3 Adjustments - RMT Approval',
  generic_validation_error: 'An unknown validation error occured',
  quantity_decreased: 'Quantity has been reduced',
  service_charge_decreased: 'Service charge decreased',
  price_protection_not_qualified: 'Price protection not qualified',
  reason_given: 'Reason given',
  restroom_services: 'Restroom Services',
  'customer_table_approval_required.title': 'Required%20Approvals',
  'customer_table_awaiting_customer_signature.title': 'Awaiting%20Signature',
  'customer_table_past_due.title': 'Past%20Due',
  quantity_less_than_one: 'Quantity cannot be set to less than 1',
  customer_eligibility: 'Eligible for Renewal on',
  start_editing: 'Start Editing',
  save_changes: 'Save Changes',
  revert_changes: 'Undo',
  renewal_term_approval_needed: 'Renewal Term Adjustment requires approval',
  code: 'Code',
  size: 'Size',
  renewal_not_available:
    'The renewal you are trying to access is no longer available. Please contact your service team with any questions.',
  error_getting_renewal:
    'An unexpected error occurred. If this re-occurs, please reach out to your service team for support.',
  generate_proposal: 'Create Agreement',
  create_agreement_pdf_dialog: 'This will create a Service Agreement to be printed and brought to the customer for signature. Do you want to proceed with creating printable Service Agreement?',
  generate_proposal_subheader: "Create Printable Service Agreement",

  /*
   * Days of the week
   */
  all_routes: 'All Routes',
  all_districts: 'All Districts',
  all_days: 'All Days',
  monday: 'Monday',
  tuesday: 'Tuesday',
  wednesday: 'Wednesday',
  thursday: 'Thursday',
  friday: 'Friday',
  saturday: 'Saturday',
  sunday: 'Sunday',

  /*
   * Customer Renewal Columns
   */
  customer_number: 'Customer #',
  customer_name: 'Customer Name',
  awr: 'AWR',
  awrv: 'AWRV',
  price_increase: 'Price Adjustment',
  exp_date: 'Exp. Date(MM/DD/YYYY)',
  route: 'Route',
  renewal_status: 'Renewal Status',
  renewals: 'Renewals',
  'requiring_approval.title': 'Requiring Approval',
  'exceptions_awaiting_customer_signature.title':
    'Awaiting Customer Signature',
  'awaiting_customer_signature.title': 'Awaiting Customer Signature',
  see_all: 'See All',
  customer_forms: 'Customer Forms',
  proposed_date: 'Proposed Date',
  resend_signature_email: 'Resend Customer Signature Email',
  base_price_increase: 'Initial Price Increase',
  /*
   * Sign out
   */
  sign_out: 'Sign out',

  /*
   * Login Page
   */
  username: 'Username',
  password: 'Password',
  login: 'Login',
  version: 'Version',

  /*
   * Completed renewal
   */
  renewed_below_MAD_or_qty_decreased: 'Renewed below MAD or Qty Decreased',
  renewal_within_MAD: 'Renewal within MAD',
  renewal_with_no_deviation: 'Renewal with no deviation',
  within_mad_classification: 'Within MAD',
  below_mad_classification: 'Below MAD / Qty Decreased',
  no_deviation_classification: 'No Deviation',
  no_classification: 'No Classification',
  completed_last_7_days: 'Completed last 7 days',
  completed_last_30_days: 'Completed last 30 days',
  completed_last_90_days: 'Completed last 90 days',
  completed_all_time: 'Completed All Time',
  all_time: 'All Time',
  completed_renewals: 'Completed Renewals',
  enter_customer_name_or_number: 'Enter Customer Name or Number',
  margin_score: 'Margin Score',
  completed: 'Completed',
  route_CSR: 'Route #/RSR',
  bucket: 'Bucket',
  completed_renewal_actions: 'Actions',
  contract: 'Contract',
  completed_renewals_portal: 'Completed Renewals Portal',
  reports_portal: 'Reports Portal',
  pdf_error_message:
    'Error: PDF is not available, please contact your administrator.',
  email_success_message: 'Email successfully sent.',
  email_error_message:
    'Error: Email failed to send, please contact your administrator.',
  /*
   * Completed Renewal Report Fields
   */
  route_number: 'Route Number',
  employee_name: 'Employee Name',
  average_weekly_revenue: 'Average Weekly Revenue',
  branch_margin_rating: 'Branch Margin Rating',
  classification: 'Classification',
  completed_date: 'Completed Date (MM/DD/YYYY)',
  selected_date_range_invalid_message:
    'Selected date range is invalid, please try again.',
  completed_renewals_report_success_message: 'CSV downloaded successfully',
  no_deviation_renewals_report_success_message:
    'Report downloaded successfully',
  completed_renewal_contracts_success_message:
    'Completed Renewal Contracts reports downloaded successfully',
  no_completed_renewals_in_this_time_period_message:
    'There are no completed renewals in the selected date range. CSV was not downloaded.',
  no_deviation_renewals_not_available_in_this_time_period_message:
    'There are no renewals with no deviation in the selected date range. CSV was not downloaded.',
  no_completed_renewal_contracts_in_this_time_period_message:
    'There are no completed renewals contracts in the selected date range. ZIP file was not downloaded.',
  completed_renewals_report_failed_to_generate_csv_message:
    'There was an error generating your report, please try again or contact your administrator',
  no_deviation_renewals_report_failed_to_generate_csv_message:
    'There was an error generating your no deviation renewal report, please try again or contact your administrator',
  completed_renewal_contracts_failed_to_generate_csv_message:
    'There was an error generating your completed renewal contracts, please try again or contact your administrator',
  completed_renewals_report_error_message:
    'There was an error getting your report, please try again or contact your administrator',
  no_market_center_report_found: 'No market center report found',
  no_awaiting_approval_found: 'No Awaiting Approval Report found',
  market_center_report_failed_respond: 'Market center report failed to respond',
  market_center_report_error_message:
    'There was an error getting your market center report',
  awaiting_approval_report_error_message:
    'There was an error getting your awaiting approval report',
  export_mc_report: 'Export Market Center Report',
  start_date: 'Start Date',
  end_date: 'End Date',
  export_completed_report: 'Export Completed Renewals Report',
  continue: 'Next',
  export_completed_renewal_contracts: 'Export Completed Renewal Contracts',
  previous_CXD: 'Previous Contract Expiration Date',
  new_CXD: 'New Contract Expiration Date',
  export_no_deviation_renewal_reports: 'Export No Deviation Renewal Reports',
  renewal_id: 'Renewal Id',
  employee_id: 'Employee Id',
  employee_role: 'Employee Role',
  district_code: 'District Code',
  completed_renewals_report: 'Completed Renewals Report',
  awaiting_approvals_report: 'Awaiting Approvals Report',
  market_center_report: 'Market Center Report',
  total_initiated: 'Total Initiated',
  dm_initiated: 'TM Initiated',
  rsr_initiated: 'RSR Initiated',
  rsr_name: 'RSR Name',
  other_initiated: 'Other Initiated',
  market_center: 'Market Center',
  proposed: 'Proposed',
  within_mad: 'Within MAD',
  total_proposed: 'Total Proposed',
  total_completed: 'Total Completed',
  total_within_mad: 'Total Within MAD',
  total_csr_proposed: 'Total RSR Proposed',
  total_csr_completed: 'Total RSR Completed',
  total_csr_within_mad: 'Total RSR Within MAD',
  total_dm_proposed: 'Total TM Proposed',
  total_dm_completed: 'Total TM Completed',
  total_dm_within_mad: 'Total TM Within MAD',
  total_other_proposed: 'Total Other Proposed',
  total_other_completed: 'Total Other Completed',
  total_other_within_mad: 'Total Other Within MAD',
  clear_reset: 'Clear / Reset',
  proposed_by: 'Proposed By',

  /*
   * Actions
   */
  'action.clear': 'Clear',
  'action.approve': 'Approve',
  'action.add': 'Add',
  'action.remove': 'Remove',
  'action.submit': 'Submit',
  /*
   * Admin Branch Pages
   */
  available_branches: 'Available Branches',
  inactive_branches: 'Inactive Branches',
  selected_branches: 'Selected Branches',
  branch_code: 'Branch Code',
  branch_description: 'Branch Description',
  manage_branch_override: 'Manage Branch Overiddes',
  /*
   * Terms And Conditions Page
   */
  twelve: 'twelve',
  twenty_four: 'twenty-four',
  thirty_six: 'thirty-six',
  fourty_eight: 'forty-eight',
  sixty: 'sixty',

  /*
   * Customer Signature Page
   */
  terms_and_conditions: 'Terms and Conditions',
  service_promise_paragraph_part_1: 'This agreement is subject to',
  service_promise_paragraph_part_2:
    'I, on behalf of Customer, agree to the Terms and Conditions of the Service Agreement(s) and am authorized to do so.',
  signature_promise:
    'I understand and agree that my signature provided above will be applied to the Service Agreement(s) and that a copy of the Service Agreement(s) will be sent to the email address provided.',
  terms_acknowledgement:
    'I, on behalf of Customer, agree to the Terms and Conditions of the Service Agreement(s) and am authorized to do so.',
  approver_full_name: 'Approver Full Name',
  approver_email: 'Approver Email',
  approver_signature: 'Approver Signature',
  thank_you:
    'Thank you for renewing your contract. You may close this window now.',
  start_signing: 'Review Terms & Conditions and Sign Agreement',
  clear: 'clear',
  redirect:
    'Signature has already been submitted. Redirecting to the Aramark Uniform home page.',
  redirect_to: 'https://www.aramarkuniform.com',
  /*
   * Customer Forms Portal Page
   */
  customer_lead: 'Customer Lead',
  tig_lead: 'TIG Lead',
  direct_sales_lead_us: 'Aramark Direct Sales Lead US',
  direct_sales_form_ca: 'Direct Sales Order Form - CA',
  internal_network_disclaimer: 'Only available on internal Aramark Network',

  /*
   * Error messages
   */
  error_001:
    'Unable to login. Please contact your administrator and have them' +
    " check yours and your branch's ABS configuration.",
  error_002: 'Invalid username or password.',
  error_003: 'An unknown problem occured.',
  error_004: 'User locked out due to too many failed login attempts.',
  error_005:
    "No valid role found for user's title. Please contact your administrator and have them update the job mappings.",
  error_006: 'Admin mode only. Non-admins cannot login currently',
  /*
   * Emblem Charges
   */
  emblem_charges: 'Emblem Charges',
  company_charge: 'Company Emblem Charge',
  name_charge: 'Name Emblem Charge',
  other_charge: 'Other Emblem Charge',
  /*
   * Users
   */
  'user.CSR': 'RSR',
  'user.CSM': 'Territory Manager',
  'user.COM': 'Service Manager',
  'user.CAM': 'CAM',
  'user.C3': 'C3',
  'user.ADMIN': 'Admin',
  'user.VPO': 'VPO',
  'user.GM': 'General Manager',
  'user.RVP': 'Regional VP',
  'user.RMT': 'Revenue Management',
  /*
   * Admin Panel
   */
  config_name: 'Name:',
  config_description: 'Description:',
  config_value: 'Value:',

  /**
   * MRS
   */
  mrs: 'Managed Restroom Services',
  back: 'Back',
  review: 'Review',
  edit: 'Edit',
  mrs_continue: 'Continue', // Regular continue actually maps to "Next"
  mrs_validation_general_error:
    'Please resolve any errors above before proceeding.',
  mrs_dispenser_required_error: 'Dispenser is required for this item.',
  mrs_dispenser_no_fill_item_error: 'Too many dispensers selected.',
  mrs_dispenser_too_many_error: 'Cannot order dispenser without fill item.',
  mrs_order_in_progress_warning:
    'There is already an in-progress order for this customer. Do you want to continue working on it?',
  mrs_order_already_completed_warning:
    'This customer already has a completed MRS order. Edits are currently not supported.',
  mrs_search_customers_hint: 'Search Customers',
  mrs_search_button_text: 'Search',
  mrs_thank_you: 'Thank you. Your order has been submitted.',

  search_existing_mrs: 'Search Existing MRS',
  create_new_mrs: 'Start New Order',
  total: 'Total'
};
